import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng-lts/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { dossierHeaderComponent } from './dossierHeader.component';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';

@NgModule({
  declarations: [dossierHeaderComponent],
  imports: [TranslateModule, CommonModule, TooltipModule, OverlayPanelModule],
  exports: [dossierHeaderComponent]
})
export class DossierHeaderModule { }
